import { ModalController } from '@ionic/angular';
import { Account, Post } from '@jaimo-solutions-gmbh/platform-services-module';
import { Subject } from 'rxjs';
import { ConsentComponent } from './app/modals/consent/consent.component';
import {
  faXTwitter,
  faMastodon,
  faInstagram,
  faYoutube,
  faLinkedin,
  faTiktok,
  faFacebookF,
  faBluesky,
  faThreads,
} from '@fortawesome/free-brands-svg-icons';
import { faRss, faBug } from '@fortawesome/free-solid-svg-icons';
import { DesktopFullscreenComponent } from './app/modals/desktop-fullscreen/desktop-fullscreen.component';
import { MobileFullscreenComponent } from './app/modals/mobile-fullscreen/mobile-fullscreen.component';
import { ShareComponent } from './app/modals/share/share.component';
import { StoriesComponent } from './app/modals/stories/stories.component';
import { Platform } from '@jaimo-solutions-gmbh/platform-services-module/lib/platforms';

const pages = ['explore', 'followed', 'search', '404'];

export type State =
  | 'post'
  | 'explore'
  | 'followed'
  | 'bookmarks'
  | 'search'
  | '404'
  | 'stage'
  | 'main';

export const stateSubject = new Subject<{ state: State; value?: string }>();

const xTwitterIcon = faXTwitter;
const facebookIcon = faFacebookF;
const mastodonIcon = faMastodon;
const instagramIcon = faInstagram;
const youtubeIcon = faYoutube;
const linkedInIcon = faLinkedin;
const tiktokIcon = faTiktok;
const rssIcon = faRss;
const blueskyIcon = faBluesky;
const threadsIcon =faThreads;

export const openConsent = (
  url: string,
  platform: Platform,
  modalCtrl: ModalController
) => {
  if (platform === 'rss' || url.includes('stage.bio')) {
    window.open(url, '_blank');
  } else {
    modalCtrl
      .create({
        component: ConsentComponent,
        cssClass: 'consent-popover',
        componentProps: { url, platform },
      })
      .then((modal) => {
        modal.present();
      });
  }
};

export const openShare = (data: Account | Post, modalCtrl: ModalController) => {
  modalCtrl
    .create({
      component: ShareComponent,
      componentProps: {
        data,
      },
      cssClass: 'settings-popover',
    })
    .then((modal) => {
      modal.present();
    });
};

export const openFullscreen = (
  post: Post,
  index: number,
  modalCtrl: ModalController,
  presentingElement?: HTMLElement
) => {
  const clone = Object.create(post);
  modalCtrl
    .create({
      component: isDesktop()
        ? DesktopFullscreenComponent
        : MobileFullscreenComponent,
      canDismiss: true,
      cssClass: 'fullscreen-modal',
      presentingElement,
      componentProps: {
        index,
        post: clone,
      },
    })
    .then((modal) => {
      modal.present();
    });
};

export const getActiveStageName = () => {
  const path = location.pathname.slice(1);
  if (path.includes('/')) {
    return path.substring(0, path.indexOf('/'));
  }
  return location.pathname.substr(1, location.pathname.length);
};

export const isPage = (name) => pages.includes(name);

export const getIcon = (platform?: Platform) => {
  switch (platform) {
    case 'x-twitter':
      return xTwitterIcon;
    case 'instagram':
      return instagramIcon;
    case 'facebook':
      return facebookIcon;
    case 'mastodon':
      return mastodonIcon;
    case 'rss':
      return rssIcon;
    case 'linkedin':
      return linkedInIcon;
    case 'youtube':
      return youtubeIcon;
    case 'tiktok':
      return tiktokIcon;
    case 'bluesky':
      return blueskyIcon;
    case 'threads':
      return threadsIcon;
    default:
      return faBug;
  }
};

export const getState = (): State => {
  const path = location.pathname.substr(1, location.pathname.length);
  if (path.includes('/')) {
    return 'post';
  }
  if (path !== '') {
    switch (path) {
      case 'explore':
      case 'followed':
      case 'bookmarks':
      case 'search':
      case '404':
        return path;
      default:
        return 'stage';
    }
  } else {
    return 'main';
  }
};

export const viewStories = (account: Account, modalCtrl: ModalController) => {
  modalCtrl
    .create({
      component: StoriesComponent,
      cssClass: 'stories-modal',
      componentProps: { account },
    })
    .then((modal) => modal.present());
};

export const scrollTo = (element, to, duration) => {
  to = to.offsetLeft;
  const start = element.scrollLeft;
  const change = to - start - 8;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, change, duration);
    element.scrollLeft = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
};

export const isDesktop = () => window.innerWidth >= 992;

//t = current time
//b = start value
//c = change in value
//d = duration
function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) {
    return (c / 2) * t * t + b;
  }
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
}
